module.exports = __webpack_public_path__ + "img/4.17b5ee18.jpg";